import { Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import useStyles from './Image.styles';
import { FindingShape } from '../../../finding/models/Finding';
import useAgent from '../../hooks/useAgent';
import findingAgent from '../../../finding/agents/findingAgent';

const Image = ({ isVisible, patrolId, finding }) => {
  const classes = useStyles();
  const [fetchImage, imageResult] = useAgent(findingAgent.getFindingImage);
  const [isManualIcon, setIsManualIcon] = React.useState(false);
  const imageUrl = finding.imagePath || imageResult?.imagePath;

  useEffect(() => {
    if (isVisible && !finding.imagePath && !imageResult) fetchImage(patrolId, finding.id);
  }, [isVisible, finding.imagePath, imageResult, fetchImage, finding.id, patrolId]);

  const handleImageLoad = useCallback((event) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    setIsManualIcon(naturalWidth <= 128 && naturalHeight <= 128);
  }, []);

  if (!imageUrl) return <Avatar variant="square" className={classes.image} />;

  const imageClass = isManualIcon ? classes.overriddenImage : classes.image;

  return <img alt="" src={imageUrl} className={imageClass} onLoad={handleImageLoad} />;
};

Image.propTypes = {
  isVisible: PropTypes.bool,
  patrolId: PropTypes.number.isRequired,
  finding: FindingShape.isRequired,
};

Image.defaultProps = {
  isVisible: true,
};

export default React.memo(Image);
